// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3M7Xz","input":"styles_input__EJQ5Z"};